import type { Stage } from "./api";

const CHANNELS: Record<string, string> = {
  email: "Email", instagram: "Instagram", linkedin: "LinkedIn", threads: "Threads", facebook: "Facebook", youtube: "YouTube",
  tiktok: "TikTok", product_page: "Product page", amazon_listing: "Amazon listing", ad: "Ad",
};

export const channelName = (value: string) => CHANNELS[value] ?? `${value.charAt(0).toUpperCase()}${value.slice(1).replaceAll("_", " ")}`;
export const versionLabel = (value: { channel: string; locale: string }) => `${channelName(value.channel)} · ${value.locale}`;
export function derivedLabel(versionId: string | null): string | null {
  if (!versionId) return null;
  const key = versionId.split(":").at(-1)?.split("-");
  return key && key.length >= 2 ? `${channelName(key[0])} · ${key.slice(1).join("-")}` : versionId;
}
export const words = (value: string) => value.split("_").map((word) => `${word.charAt(0).toUpperCase()}${word.slice(1)}`).join(" ");
export const personName = (name: string | null | undefined, email: string | null | undefined) => name?.trim() || (email ? `${email.split("@")[0].charAt(0).toUpperCase()}${email.split("@")[0].slice(1)}` : null);

export function timeInStage(seconds: number): string {
  if (seconds < 60) return "<1 min";
  if (seconds < 3600) return `${Math.floor(seconds / 60)} min`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h`;
  return `${Math.floor(seconds / 86400)}d`;
}

export const stageName = (stage: Stage | string) => words(stage);
export const stageMark = (stage: Stage) => stage === "queued" ? "○ " : stage === "distributed" ? "✓ " : "";
export const formatClock = (date = new Date()) => date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
